module.exports = __webpack_public_path__ + "img/WS.d80fc4d3.png";